<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>供应点管理</el-breadcrumb-item>
        <el-breadcrumb-item>核销记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :rules="checkListParams" ref="listParamsForm" :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：" prop="date">
              <el-select clearable style="width: 100%" v-model="listParams.date" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.dateId" :key="item.dateId" :label="item.date | formatDate"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="cancelOrder"-->
          <!--:disabled="orderIdList.length === 0">-->
          <!--一键核销-->
          <!--</el-button>-->
          <span style="color: red; line-height: 32px; padding-left: 20px">注：系统将于下一个领货日期前一天晚上11点自动核销</span>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="orderNo" align="center" label="订单编号">
          <template slot-scope="scope">
            <div v-if="scope.row.orderNo">
              <div v-if="scope.row.orderNo.length > 10">
                <el-popover ref="popover1" placement="top-start" width="200" trigger="hover" :content="scope.row.orderNo"> </el-popover>
                <el-button style="color: #606266" type="text" v-popover:popover1>
                  {{ scope.row.orderNo | formatLimitLength }}
                </el-button>
              </div>
              <div v-else>
                {{ scope.row.orderNo }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号"> </el-table-column>

        <el-table-column prop="goodsTitle" align="center" label="菜品名称">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.tradeGoodsList" :key="index">
              <span>{{ item.goodsTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="specTitle" align="center" label="规格">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.tradeGoodsList" :key="index">
              <span>{{ item.specTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="quantity" align="center" label="数量">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.tradeGoodsList" :key="index">
              <span>{{ item.quantity }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price" align="center" label="价格(元)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.tradeGoodsList" :key="index">
              <span>{{ item.price | formatToFixed2 }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="status" align="center" label="状态">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.tradeGoodsList" :key="index">
              <span v-if="item.status === 0">已完成</span>
              <span v-else-if="item.status === 1">已退货</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        date: "",
        id: "",
        supplyId: "",
      },
      checkListParams: {
        date: [{ required: true, message: "请选择领货日期", trigger: "change" }],
      },
      orderIdList: [],
      dateList: [],
      tableLoading: false,
      tableData: [],
      selectionList: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.listParams.id = this.$route.params.supplyCentreId;
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadDateList();
  },
  methods: {
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/logistics/goods-management-date",
        method: "GET",
        params: {
          id: this.listParams.id,
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data.dateList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$refs.listParamsForm.validate(valid => {
        if (valid) {
          const bodyParams = Object.assign({}, this.listParams, {
            pageIndex: this.pager.pageIndex,
            pageSize: this.pager.pageSize,
          });
          this.$http({
            url: global.apiUrl + "/logistics/trade",
            method: "GET",
            params: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.tableLoading = false;
                if (res.body.data) {
                  this.tableData = res.body.data.dataList;
                  if (this.tableData) {
                    this.tableData.map(item => {
                      this.orderIdList.push(item.id);
                    });
                  }
                  this.pager.total = res.body.data.total;
                } else {
                  this.tableData = [];
                }
              } else {
                this.tableLoading = false;
              }
            })
            .catch(err => {
              this.tableLoading = false;

              console.error(err);
            });
        } else {
          this.tableLoading = false;
        }
      });
    },
    /**
     * 核销订单
     */
    cancelOrder() {
      this.$http({
        url: global.apiUrl + "/logistics/trade-insert",
        method: "POST",
        body: {
          list: this.orderIdList,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
